/**
 * Tarih formatını "25 Haziran 2023" şeklinde döndürür
 * @param {string|Date} dateString - API'den gelen tarih string'i veya Date objesi
 * @returns {string} Formatlanmış tarih string'i
 */
export const formatDate = (dateString) => {
  try {
    if (!dateString) return "";
    
    const date = new Date(dateString);
    
    if (isNaN(date.getTime())) {
      return dateString; // Geçersiz tarih olması durumunda orijinal değeri döndür
    }
    
    const options = { 
      year: 'numeric', 
      month: 'long', 
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    };
    
    return date.toLocaleDateString('tr-TR', options);
  } catch (error) {
    console.error('Tarih formatlanırken hata:', error);
    return dateString;
  }
};

/**
 * Tarihi kısa formatta "25.06.2023" şeklinde döndürür
 * @param {string|Date} dateString - API'den gelen tarih string'i veya Date objesi
 * @returns {string} Formatlanmış tarih string'i
 */
export const formatShortDate = (dateString) => {
  try {
    if (!dateString) return "";
    
    const date = new Date(dateString);
    
    if (isNaN(date.getTime())) {
      return dateString;
    }
    
    const options = { 
      year: 'numeric', 
      month: '2-digit', 
      day: '2-digit'
    };
    
    return date.toLocaleDateString('tr-TR', options);
  } catch (error) {
    console.error('Tarih formatlanırken hata:', error);
    return dateString;
  }
}; 